import { render, staticRenderFns } from "./LabelDropdown.vue?vue&type=template&id=3ca81a1e&scoped=true"
import script from "./LabelDropdown.vue?vue&type=script&lang=ts"
export * from "./LabelDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca81a1e",
  null
  
)

export default component.exports